export default __webpack_public_path__ + "static/media/remove.1d14d2a3.svg";